import { elevatorCompany } from "core/UrlEndpoints";
import CrudService from "./CrudService";
import { fetchData } from "../FetchApi";

class ElevatorCompanyService extends CrudService {
  constructor() {
    super(elevatorCompany);
  }

  async sendSmsInvite(data) {
    return fetchData(`${elevatorCompany}/SendSmsInvite`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }
}

export default new ElevatorCompanyService();
